import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const OneLiner = ({oneLiner}) => (
    <small>{oneLiner}</small>
);

OneLiner.propTypes = {
    oneLiner: PropTypes.string
};

export default OneLiner;
